import {NeoButton, NeoTextBox} from "@/components/forms";
import {NeoHeader} from "@/components/shared";
import {routePlanService} from "@/service/routePlan.service";
import {yupResolver} from "@hookform/resolvers/yup";
import {useEffect, useState} from "react";
import {Controller, useForm} from "react-hook-form";
import {AiOutlineLoading} from "react-icons/ai";
import * as yup from "yup";

export const CreateRoutePlan = function ({
  onClose,
  editData
}: {
  onClose: Function;
  editData: RoutePlan | null;
}) {
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const validationSchema = yup.object().shape({
    name: yup.string().required("Please enter your name")
  });

  const {
    reset,
    resetField,
    register,
    handleSubmit,
    formState: {isSubmitting, isValid, errors},
    control,
    setValue,
    setError,
    clearErrors
  } = useForm<any>({
    // defaultValues: {
    //   name: ""
    // },
    mode: "onChange",
    resolver: yupResolver(validationSchema)
  });

  useEffect(() => {
    const prefill = editData?.planName ?? editData?.planName ?? "";
    reset({name: prefill});
  }, [editData?.planName, reset]);
  const onSubmit = (data: any) => {
    setLoading(true);
    const planId = editData?.planId ?? null;
    routePlanService
      .addEditPlanName(data, planId)
      .then(response => {
        if (response?.data?.status === "success") {
          onClose();
        } else {
          setErrorMessage(response?.data?.message || "Something went wrong");
        }
      })
      .catch(err => {
        if (err?.errors?.length > 0) {
          err?.errors?.forEach(
            ({field, message}: {field: any; message: string}) => {
              setError(field, {type: "server", message: message});
            }
          );
        }
      })
      .finally(() => {
        setLoading(false);
        setTimeout(() => {
          setErrorMessage(null);
        }, 2000);
      });
  };
  return (
    // <div className="flex min-h-[calc(100vh-63px)] w-full flex-col p-5">
    <>
      <div className="flex-row">
        <NeoHeader message={editData ? "Edit Plan" : "Create Plan"} />
      </div>
      <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
        <div className="py-2">
          <Controller
            name="name"
            control={control}
            render={({field, fieldState}) => (
              <NeoTextBox
                {...field}
                label={
                  <span>
                    Plan Name <span className="text-red-500">*</span>
                  </span>
                }
                id="name"
                type="text"
                placeholder="Plan Name"
                color={errors.name ? "danger" : "default"}
                isInvalid={errors.name ? true : false}
                errorMessage={errors.name && `${errors.name.message}`}
                {...register("name")}
              />
            )}
          />

          {/*  */}
        </div>
        <div className="flex items-center justify-end p-1">
          <NeoButton
            className="mx-1 bg-[#FFC727] text-[#000000]"
            type="submit"
            size="sm"
            disabled={isSubmitting}
            isLoading={loading}
            spinner={
              <AiOutlineLoading size="xs" className="animate-spin h-6 w-6" />
            }
            color="black"
          >
            Submit
          </NeoButton>
        </div>
        {errorMessage && (
          <span className="p-1 text-tiny text-danger">{errorMessage}</span>
        )}
      </form>
    </>
    // </div>
  );
};
